import React from "react";

import { Drawer } from "antd";
import { RiCloseFill } from "react-icons/ri";

import MenuLogo from "../logo";
import MenuItem from "../item";
import MenuFooter from "../footer";

export default function MenuMobile(props) {
  const { onClose, visible } = props;

  let management = window.localStorage.getItem("menu")
    ? JSON.parse(window.localStorage.getItem("menu"))
    : {};

  let check = (management.role_management
    ? management.role_management
    : []
  ).find((el) => {
    return el.menu === "Setting" && new RegExp("R").test(el.access);
  });

  return (
    <Drawer
      title={<MenuLogo onClose={onClose} />}
      width={256}
      className="hp-mobile-sidebar"
      placement="left"
      closable={true}
      onClose={onClose}
      open={visible}
      closeIcon={
        <RiCloseFill className="remix-icon hp-text-color-black-80" size={24} />
      }
    >
      <div
        style={{
          height: "calc(100vh - 220px)",
        }}
      >
        <MenuItem onClose={onClose} />
      </div>

      {check ? (
        new RegExp("R").test(check.access) ? (
          <MenuFooter onClose={onClose} collapsed={false} />
        ) : null
      ) : null}
    </Drawer>
  );
}
